import { JsonSchema } from '@jsonforms/core';

export interface FileDownload {
  id: number;
  tag: string;
  description: string;
  status: number;
  status_description: string;
  last_result: string;
  request_parameters: JsonSchema;
}

export enum FileDownloadStatus {
  PARAMS = 0,
  WAITING = 1,
  GENERATING = 2,
  DONE = 3,
  ERROR = 4
}
